/**
 * ns.wow Theme
 * Facade class for public accessible core functionality.
 */

class NSTheme {

  static version() {
    return NSContext.theme.version;
  }

}

export default NSTheme;
